<template>
  <div class="page-wrap">
    <!-- <div id="map_container"></div> -->
    <!-- 地图 -->
    <div id="chart-panel" v-if="isRequest==1" class="page-map"><v-chart ref="map" :options="shopMapOpt"/></div>
    <!-- 标题栏 -->
    <div class="bi-title-wrap" >
      <div class="bi-title-left">
        <div class="bi-logo"></div>
        <dv-decoration-3 class="title-decoration" />
      </div>
      <div class="bi-title-main" @click="fullScreen">
        <h1>全国门店数据平台</h1>        
      </div>
      <div class="bi-title-right">
        <div class="bi-title-timer">
          <!-- <span class="arrow" @click="prevYear">&lt;</span> -->
          <span class="title">{{date|formatDate(this)}}</span>
          <!-- <span class="arrow" @click="nextYear">&gt;</span> -->
        </div>
      </div>      
    </div>
    <template v-if="isRequest==1">
    <!-- 平台门店总数 -->    
    <div class="shop-total-wrap panel-wrap">
      <div class="light"></div>
      <div class="light2"></div>
      <div class="bg"></div>
      <div class="panel-container">
        <div class="panel-item">
          <div class="flex-row">
            <div class="chart-title">本月新增 <i class="icon-up"></i></div>
            <span class="chart-util" style="margin-right: 20px;"><span class="color-light">{{shopNumMonth}}</span> 家</span>
          </div>
          <div class="penel-title pointer" style="font-size: 22px;" @click="showModal(2)">平台门店总数</div>    
          <div class="total-nums"><b><countTo :startVal='0' :endVal='shopNum' :duration='duration' /></b>家</div>
        </div>
        <div class="panel-item">
          <div class="flex-row">
            <div class="chart-title pointer" @click="showModal(2)">各省门店排行 <span>Top5</span></div>
            <span class="chart-util">家</span>
          </div>
          <div style="width: 100%;height: 140px;">
            <v-chart :options="shopsBarOpt"/>
          </div>
        </div>
        <div class="panel-item">
          <div class="flex-row">
            <div class="chart-title">门店年增长</div>
            <span class="chart-util">家</span>
          </div>
          <div style="width: 100%;height: 140px;">
            <v-chart :options="riseLineOpt"/>
          </div>
        </div>
      </div>
    </div>
    <!-- 今日销售总额 -->
    <div class="today-sale-wrap panel-wrap">
      <div class="light"></div>
      <div class="light2"></div>
      <div class="bg"></div>
      <div class="panel-container">
        <div class="panel-item">
          <div class="penel-title line pointer" @click="showModal(3)">今日销售总额 <i class="icon-up"></i> 
            <!-- <span style="font-size: 14px;margin-left: 10px;">今日</span> -->
            <!-- <span class="color-light" style=""><countTo :startVal='0' :endVal='todaySaleNum' :duration='duration' /></span> -->
          </div>
          <div class="sale-nums"><b><countTo style="color: #FF2A70;" :startVal='0' :endVal='todaySaleNum' :duration='duration' /></b> 元</div>
          <div class="month-title">本月新增 <countTo :startVal='0' :endVal='monthSaleNum' :duration='duration' />元</div>          
        </div>
        <div class="panel-item">
          <div class="penel-title line pointer" @click="showModal(3)">今日成交件数 <i class="icon-up"></i> 
            <!-- <span style="font-size: 14px;margin-left: 10px;">今日</span>
            <span class="color-light"><countTo :startVal='0' :endVal='todayVolNum' :duration='duration' /></span> -->
          </div>
          <div class="sale-nums"><b><countTo style="color: #FF2A70;" :startVal='0' :endVal='todayVolNum' :duration='duration' /></b> 件</div>
          <div class="month-title">本月新增 <countTo :startVal='0' :endVal='monthVolNum' :duration='duration' />件</div>
        </div>
        <div class="panel-item">
          <div class="penel-title line pointer" @click="showModal(3)">今日新增会员 <i class="icon-up"></i> 
          <!-- <span style="font-size: 14px;margin-left: 10px;">今日</span>
            <span class="color-light"><countTo :startVal='0' :endVal='todayCustomNum' :duration='duration' /></span> -->
          </div>
          <div class="sale-nums"><b><countTo style="color: #FF2A70;" :startVal='0' :endVal='todayCustomNum' :duration='duration' /></b> 人</div>
          <div class="month-title">本月新增 <countTo :startVal='0' :endVal='monthCustomNum' :duration='duration' />人</div>
        </div>
      </div>
    </div>
    <!-- 平台销售总额 -->
    <div class="shop-sale-wrap panel-wrap">
      <div class="light"></div>
      <div class="light2"></div>
      <div class="bg"></div>
      <div class="panel-container">
        <div class="panel-item">
          <div class="penel-title line pointer" @click="showModal(3)">年销售总额
            <!-- <i class="icon-up"></i> 
            <span style="font-size: 14px;margin-left: 10px;">今日</span>
            <span class="color-light" style=""><countTo :startVal='0' :endVal='todaySaleNum' :duration='duration' /></span> -->
          </div>
          <div class="sale-nums"><b><countTo :startVal='0' :endVal='saleSum' :duration='duration' /></b>万元</div>
          <div class="flex-row mt20">
            <div class="chart-title">销售总额月增长</div>
          </div>
          <div style="width: 100%;height: 110px;">
            <v-chart :options="saleLineOpt"/>
          </div>
        </div>
        <div class="panel-item">
          <div class="penel-title line pointer" @click="showModal(3)">年成交件数
            <!-- <i class="icon-up"></i> 
            <span style="font-size: 14px;margin-left: 10px;">今日</span>
            <span class="color-light"><countTo :startVal='0' :endVal='todayVolNum' :duration='duration' /></span> -->
          </div>
          <div class="sale-nums"><b><countTo :startVal='0' :endVal='goodsSum' :duration='duration' /></b>件</div>
          <div class="flex-row mt20">
            <div class="chart-title">成交件数月增长</div>
          </div>
          <div style="width: 100%;height: 110px;">
            <v-chart :options="volLineOpt"/>
          </div>
        </div>
        <div class="panel-item">
          <div class="penel-title line pointer" @click="showModal(3)">年会员总数
            <!-- <i class="icon-up"></i> 
            <span style="font-size: 14px;margin-left: 10px;">今日</span>
            <span class="color-light"><countTo :startVal='0' :endVal='todayCustomNum' :duration='duration' /></span> -->
          </div>
          <div class="sale-nums"><b><countTo :startVal='0' :endVal='custSum' :duration='duration' /></b>人</div>
          <div class="flex-row mt20">
            <div class="chart-title">会员年增长量</div>
          </div>
          <div style="width: 100%;height: 110px;">
            <v-chart :options="vipLineOpt"/>
          </div>
        </div>
      </div>
    </div>
    <!-- 库存量和铺货成本 -->
    <div class="shop-stock-wrap panel-wrap">
      <div class="light"></div>
      <div class="light2"></div>
      <div class="bg"></div>
      <div class="panel-container column">
        <div class="panel-item">
          <div class="flex-row">
            <div class="chart-title line pointer" @click="showModal(0)">各省平均库存量 <span>Top5</span></div>
            <span class="chart-util">千件</span>
          </div>
          <div style="width: 100%;height: 180px;">
            <v-chart :options="stockBarOpt"/>
          </div>
          <div class="flex-row mt20">
            <div class="chart-title line pointer" @click="showModal(0)">各省平均铺货成本 <span>Top5</span></div>
            <span class="chart-util">万元</span>
          </div>
          <div style="width: 100%;height: 180px;">
            <v-chart :options="costBarOpt"/>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付方式占比 -->
    <div class="shop-pay-wrap panel-wrap">
      <div class="light"></div>
      <div class="light2"></div>
      <div class="bg"></div>
      <div class="panel-container column">
        <div class="panel-item">
          <div class="flex-row">
            <div class="chart-title line pointer" @click="showModal(1)">门店支付方式占比</div>
            <span class="chart-util">万元</span>
          </div>
          <div style="width: 100%;height: 270px;">
            <v-chart ref="payPie" :options="payPieOpt"/>
          </div>
          <div class="flex-row">
            <div class="chart-title line pointer" @click="showModal(1)">支付习惯各省排行</div>
          </div>
          <div style="width: 100%;height: 130px;">
            <v-chart :options="habitPieOpt"/>
          </div>
        </div>
      </div>
    </div>    
    <div class="bi-box-wrapper" ref="boxWrapper" v-show="modalShow">
      <transition name="fade">
        <div class="bi-modal" v-show="modalShow" @click="hideModal"></div>
      </transition>
      <transition name="slide-fade">
        <div class="bi-inner-wrap" v-show="modalShow">
          <div class="bg"></div>
          <div class="bi-inner-tabs">
            <ul>
              <li :class="index===tabActive?'active':''" v-for="(item, index) in tabList" :key="index" @click="tabActive=index"><span>{{item}}</span></li>
            </ul>
          </div>
          <!-- 库存成本 -->
          <div class="bi-inner-container" v-show="tabActive===0">
            <div class="flex-row">
              <div class="flex-title">
                <div class="chart-title line">各省平均库存量</div>
                <span class="chart-util">{{ innerStockBarAmount }} 千件</span>
              </div>
              <div class="flex-title">
                <div class="chart-title line">各省平均铺货成本</div>
                <span class="chart-util">{{ innerCostBarAmount }}万元</span>
              </div>
            </div>
            <div class="flex-row" style="height: 650px;overflow-y: auto;">
              <div class="flex-1">
                <div style="width: 100%;height: 1000px;">
                  <v-chart :options="innerStockBarOpt" :autoresize="true"/>
                </div>
              </div>
              <div class="flex-1">
                <div style="width: 100%;height: 1000px;">
                  <v-chart :options="innerCostBarOpt" :autoresize="true"/>
                </div>
              </div>
            </div>
          </div>
          <!-- 支付习惯 -->
          <div class="bi-inner-container" v-show="tabActive===1">
            <div class="flex-row">
              <div class="flex-title">
                <div class="chart-title line wechat">微信支付</div>
                <span class="chart-util">{{ innerWeixinBarAmount }} 万元</span>
              </div>
              <div class="flex-title">
                <div class="chart-title line alipay">支付宝</div>
                <span class="chart-util">{{ innerAlipayBarAmount }} 万元</span>
              </div>
              <div class="flex-title">
                <div class="chart-title line card">刷卡</div>
                <span class="chart-util">{{ innerCardBarAmount }} 万元</span>
              </div>
              <div class="flex-title">
                <div class="chart-title line cash">现金</div>
                <span class="chart-util">{{ innerCashBarAmount }} 万元</span>
              </div>
              <div class="flex-title">
                <div class="chart-title line cash">聚合支付</div>
                <span class="chart-util">{{ innerMashupBarAmount }} 万元</span>
              </div>               
            </div>
            <div class="flex-row" style="height: 650px;overflow-y: auto;">
              <div class="flex-1">
                <div style="width: 100%;height: 1000px;">
                  <v-chart :options="innerWeixinBarOpt" :autoresize="true"/>
                </div>
              </div>
              <div class="flex-1">
                <div style="width: 100%;height: 1000px;">
                  <v-chart :options="innerAlipayBarOpt" :autoresize="true"/>
                </div>
              </div>
              <div class="flex-1">
                <div style="width: 100%;height: 1000px;">
                  <v-chart :options="innerCardBarOpt" :autoresize="true"/>
                </div>
              </div>
              <div class="flex-1">
                <div style="width: 100%;height: 1000px;">
                  <v-chart :options="innerCashBarOpt" :autoresize="true"/>
                </div>
              </div>
              <div class="flex-1">
                <div style="width: 100%;height: 1000px;">
                  <v-chart :options="innerMashupBarOpt" :autoresize="true"/>
                </div>
              </div>
            </div>
          </div>
          <!-- 门店明细 -->
          <div class="bi-inner-container" v-show="tabActive===2">
            <div class="flex-row">
              <div class="flex-title">
                <div class="chart-title line">各省门店排行</div>
                <span class="chart-util">{{ innerShopsBarAmount }} 家</span>
              </div>
            </div>
            <div class="flex-row" style="height: 650px;overflow-y: auto;">
              <div class="flex-1">
                <div style="width: 100%;height: 1000px;">
                  <v-chart :options="innerShopsBarOpt" :autoresize="true"/>
                </div>
              </div>
            </div>
          </div>
          <!-- 销售明细 -->
          <div class="bi-inner-container" v-show="tabActive===3">
            <div class="flex-row">
              <div class="flex-title">
                <div class="chart-title line alipay">销售总额</div>
                <span class="chart-util">{{ saleSum }} 万元</span>
              </div>
              <div class="flex-title">
                <div class="chart-title line card">成交件数</div>
                <span class="chart-util">{{ goodsSum }} 件</span>
              </div>
              <div class="flex-title">
                <div class="chart-title line cash">会员总数</div>
                <span class="chart-util">{{ custSum }} 人</span>
              </div>
            </div>
            <div class="flex-row" style="height: 650px;overflow-y: auto;">
              <div class="flex-1">
                <div style="width: 100%;height: 1000px;">
                  <v-chart :options="saleDetailsList" :autoresize="true"/>
                </div>
              </div>
              <div class="flex-1">                
                <div style="width: 100%;height: 1000px;">
                  <v-chart :options="goodsDetailsList" :autoresize="true"/>
                </div>
              </div>
              <div class="flex-1">                
                <div style="width: 100%;height: 1000px;">
                  <v-chart :options="custDetailsList" :autoresize="true"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    </template>
    <div style="text-align: text;margin-top: 360px;" v-if="isRequest==0">
      <dv-loading>加载中...</dv-loading>
    </div>
    <template v-if="isRequest==2">
      <div class="bi-modal"></div>
      <div class="noPower"></div>
    </template>
  </div>
</template>
<script>
import Vue from 'vue';
import CountTo from 'vue-count-to';
import ECharts from 'vue-echarts';
// import BigNumber from 'bignumber.js';
import API from '@/api/index';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/pie';
import 'echarts/lib/chart/map';
// import 'echarts/map/js/world';
import 'echarts/lib/component/tooltip';
import 'echarts/theme/dark';

import chinaMap from '../assets/json/china.json';

// 各省门店数
import shopsBarOpt from '../data/shopsBarOpt';
// 各省门店年增长
import riseLineOpt from '../data/riseLineOpt';
// 销售总额年增长
import saleLineOpt from '../data/saleLineOpt';
// 成交笔数年增长
import volLineOpt from '../data/volLineOpt';
// 会员年增长量
import vipLineOpt from '../data/vipLineOpt';
// 各省平均库存量
import stockBarOpt from '../data/stockBarOpt';
// 各省平均铺货成本
import costBarOpt from '../data/costBarOpt';
// 门店支付方式占比
import payPieOpt from '../data/payPieOpt';
// 支付习惯各省排行
import habitPieOpt from '../data/habitPieOpt';
// 地图
// import shopMapOpt, { geoCoordMap, chinaDatas } from '../data/shopMapOpt';
// import shopMapOpt from '../data/shopMapOpt';
import mapOpt, { convertData } from '../data/mapOpt';

// 弹出框-各省平均库存量
// import innerStockBarOpt from '../data/innerStockBarOpt';
// 弹出框-各省平均铺货成本
// import innerCostBarOpt from '../data/innerCostBarOpt';
// import styleJson from '../data/styleJson';
// 弹出框-通用柱状图
import innerBarOpt from '../data/innerBarOpt';
import util from '@/util/index';
import screenfull from 'screenfull';

import { loading, decoration3 } from '@jiaminghi/data-view';

Vue.use(loading);
Vue.use(decoration3);

// registering map data
ECharts.registerMap('china', chinaMap);

const replaceName = (data, key = 'item') => {
  const res = data.map((item) => {
    const name = item[key];
    let formatName = '';
    switch (name) {
      case '宁夏回族自治区':
        formatName = '宁夏';
        break;
      case '新疆维吾尔自治区':
        formatName = '新疆';
        break;
      case '西藏自治区':
        formatName = '西藏';
        break;
      case '内蒙古自治区':
        formatName = '内蒙古';
        break;
      case '广西壮族自治区':
        formatName = '广西';
        break;
      case '香港特别行政区':
        formatName = '香港';
        break;
      case '澳门特别行政区':
        formatName = '澳门';
        break;
      case '台湾省':
        formatName = '台湾';
        break;
      // case '其它':
      //   formatName = '广东';
      //   break;
      default:
        if (name.indexOf('省') > -1 || name.indexOf('市') > -1) {
          formatName = name.substring(0, name.length - 1);
        } else {
          formatName = name;
        }
        if (key === 'provice' && name === '其它') {
          formatName = '广东';
        }
        break;
    }
    return {
      ...item,
      [key]: formatName,      
    };
  });
  return res;
};

/* eslint-disable no-undef */
export default {
  name: 'Home',
  data() {
    return {
      shopsBarOpt: {},
      riseLineOpt: {},
      saleLineOpt: {},
      volLineOpt: {},
      vipLineOpt: {},
      stockBarOpt: {},
      costBarOpt: {},
      payPieOpt: {},
      habitPieOpt: {},
      shopMapOpt: mapOpt,
      timer: null,
      dateTimer: null,
      refreshTimer: null,
      date: new Date(),
      // wrapShow: false,
      modalShow: false,
      tabActive: 0,
      tabList: ['库存成本', '支付习惯', '门店明细', '销售明细'],
      innerStockBarOpt: {},
      innerCostBarOpt: {},
      duration: 1000,
      saleSum: 0,
      custSum: 0,
      goodsSum: 0,
      todaySaleNum: 0,
      todayVolNum: 0,
      todayCustomNum: 0,
      monthSaleNum: 0,
      monthVolNum: 0,
      monthCustomNum: 0,
      shopNumMonth: 0,
      showTip: null,
      shopNum: 0,
      shopTopList: [],
      // year: '2020',
      innerShopsBarOpt: {},
      innerWeixinBarOpt: {},
      innerAlipayBarOpt: {},
      innerCardBarOpt: {},
      innerCashBarOpt: {},
      innerMashupBarOpt: {},
      custDetailsList: {},
      goodsDetailsList: {},
      saleDetailsList: {},
      virtualList: [],
      sheetList: [],
      proviceList: [],
      isRequest: 0,
      seriesShopSum: 0,
      tomorrow: '',
      payTimer: null
    };
  },
  computed: {
    year() {
      return this.date.getFullYear();
    },
    innerStockBarAmount() {
      // console.log(this.innerStockBarOpt.yAxis[1].data);
      if (this.innerStockBarOpt.yAxis) {
        const { data } = this.innerStockBarOpt.yAxis[1];
        const result = data.reduce((total, num) => total + num);
        return parseFloat(result / 1000).toFixed(2);
      }
      return 0;
    },
    innerCostBarAmount() {
      if (this.innerCostBarOpt.yAxis) {
        const { data } = this.innerCostBarOpt.yAxis[1];
        const result = data.reduce((total, num) => total + num);
        return parseFloat(result / 10000).toFixed(2);
      }
      return 0;
    },
    innerWeixinBarAmount() {
      if (this.innerWeixinBarOpt.yAxis) {
        const { data } = this.innerWeixinBarOpt.yAxis[1];
        const result = data.reduce((total, num) => total + num);
        return parseFloat(result / 10000).toFixed(2);
      }
      return 0;
    },
    innerAlipayBarAmount() {
      if (this.innerAlipayBarOpt.yAxis) {
        const { data } = this.innerAlipayBarOpt.yAxis[1];
        const result = data.reduce((total, num) => total + num);
        return parseFloat(result / 10000).toFixed(2);
      }
      return 0;
    },
    innerCardBarAmount() {
      if (this.innerCardBarOpt.yAxis) {
        const { data } = this.innerCardBarOpt.yAxis[1];
        const result = data.reduce((total, num) => total + num);
        return parseFloat(result / 10000).toFixed(2);
      }
      return 0;
    },
    innerCashBarAmount() {
      if (this.innerCashBarOpt.yAxis) {
        const { data } = this.innerCashBarOpt.yAxis[1];
        const result = data.reduce((total, num) => total + num);
        return parseFloat(result / 10000).toFixed(2);
      }
      return 0;
    },
    innerMashupBarAmount() {
      if (this.innerMashupBarOpt.yAxis) {
        const { data } = this.innerMashupBarOpt.yAxis[1];
        const result = data.reduce((total, num) => total + num);
        return parseFloat(result / 10000).toFixed(2);
      }
      return 0;
    },
    innerShopsBarAmount() {
      if (this.innerShopsBarOpt.yAxis) {
        const { data } = this.innerShopsBarOpt.yAxis[1];
        const result = data.reduce((total, num) => total + num);
        return result;
      }
      return 0;
    },
  },
  created() {
    // 初始化
    this.checkIp();    
  },
  mounted() {
    const _this = this;
    this.$nextTick(() => {
      _this.date = new Date(); // 获取当前日期
      // 设置地图tooltip
      // _this.setMap();
      // 设置请求定时器
      _this.requestInterval();    
      // 设置第二天刷新页面
      _this.refreshPage();
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.dateTimer) {
      clearInterval(this.dateTimer);
    }
    // eslint-disable-next-line no-unused-expressions
    this.refreshTimer && clearInterval(this.refreshTimer);
    // eslint-disable-next-line no-unused-expressions
    this.payTimer && clearInterval(this.payTimer);
  },
  methods: {
    refreshPage() {
      const _this = this;
      const date = new Date();
      date.setDate(new Date().getDate() + 1);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      this.tomorrow = date.getTime();
      // eslint-disable-next-line no-unused-expressions
      _this.dateTimer && clearInterval(_this.dateTimer);
      _this.dateTimer = setInterval(() => {
        const now = new Date();
        // console.log(`n:${now.getTime()}`);
        // console.log(`t:${_this.tomorrow}`);
        if (now.getTime() > _this.tomorrow) {
          window.location.reload();
        }
        _this.date = now;
      }, 1000);
    },
    // 是否禁止访问
    checkIp() {
      const _this = this;
      API.checkIp().then((res) => {
        const json = res.data || {};
        if (json.status === 'success') {
          _this.fetchData();
          _this.isRequest = 1;
        } else {
          _this.isRequest = 2;
        }
      });
    },
    // eslint-disable-next-line consistent-return
    fullScreen() {
      if (!screenfull.enabled) {
        this.$message({
          message: 'you browser can not work',
          type: 'warning'
        });
        return false;
      }
      screenfull.toggle();
    },
    // 请求定时器
    requestInterval() {
      const _this = this;
      if (this.isRequest === 2) {
        return;
      }
      // 门店数量10分钟请求一次
      // eslint-disable-next-line no-unused-expressions
      _this.refreshTimer && clearInterval(_this.refreshTimer);
      _this.refreshTimer = setInterval(() => {
        const hours = new Date().getHours();
        if (hours > 8 && hours < 20) {
          _this.queryMapProvinceShopsNum();
          _this.queryYearShopTrend();
          _this.queryYearPayTypeRateTop();
          _this.queryYearStockCostTop();
          // 库存成本弹出框
          _this.queryYearStockCostTopAll();
        }        
      }, 60000);
      // eslint-disable-next-line no-unused-expressions
      _this.saleTimer && clearInterval(_this.saleTimer);
      _this.saleTimer = setInterval(() => {
        const hours = new Date().getHours();
        if (hours > 8 && hours < 20) {
          _this.queryYearSaleOrderCustTrend();          
          // 大屏销售明细
          _this.queryYearSaleDetail();
          // 大屏当天统计结果返回（单金额，会员数量，成交件数）
          _this.getPortalSaleSummary();
          _this.getVirtualAddNum();
        }        
      }, 10000);
      // eslint-disable-next-line no-unused-expressions
      _this.mapTimer && clearInterval(_this.mapTimer);
      _this.mapTimer = setInterval(() => {
        const hours = new Date().getHours();
        if (hours > 8 && hours < 20) {
          _this.getSheetAddAmount();
        }        
      }, 7000);
      // setTimeout(() => {
      //   _this.animation();
      // }, 5000);
    },
    animation() {
      const _this = this;
      if (_this.sheetList.length === 0) {
        // eslint-disable-next-line no-unused-expressions
        _this.timer && clearInterval(_this.timer);
        _this.timer = null;
      } else {
        if (_this.timer) {
          return;
        }
        _this.timer = setInterval(() => {
          if (_this.sheetList.length === 0) {
            // eslint-disable-next-line no-unused-expressions
            _this.timer && clearInterval(_this.timer);
            _this.timer = null;
          }
          const runIndex = 1;
          const sheetList = _this.sheetList.filter((item, index) => index < runIndex);
          const proviceList = _this.proviceList.filter((item, index) => index < runIndex);
          _this.shopMapOpt.series[2].data = sheetList;
          _this.shopMapOpt.geo.regions = proviceList;
          _this.sheetList.splice(0, 1);
          _this.proviceList.splice(0, 1);
        }, 10000);
      }    
      // setTimeout(() => {
      //   const shopMapOpt = util.deepClone(_this.shopMapOpt);
      //   shopMapOpt.geo.regions = [];
      //   shopMapOpt.series[2].data = [];
      //   _this.shopMapOpt = shopMapOpt;
      // }, 10000); 
      // eslint-disable-next-line prefer-const
      // let i = 100;
      // _this.regionsTimer = setInterval(() => {
      //   if (_this.shopMapOpt.geo.regions.length > 0 && i > 0) {          
      //     const shopMapOpt = util.deepClone(_this.shopMapOpt);
      //     shopMapOpt.geo.regions.forEach((item) => {
      //       i--;
      //       item.itemStyle.opacity = i / 100;
      //     });
      //     _this.shopMapOpt = shopMapOpt;
      //   } else {
      //     // eslint-disable-next-line no-unused-expressions
      //     _this.regionsTimer && clearInterval(_this.regionsTimer);
      //     const shopMapOpt = util.deepClone(_this.shopMapOpt);
      //     shopMapOpt.geo.regions = [];
      //     _this.shopMapOpt = shopMapOpt;
      //   }
      // }, 100);
    },
    // 新增门店提示
    // eslint-disable-next-line consistent-return
    shopTip(vdata) {
      const _this = this;
      const myChart = _this.$refs.map.chart;
      myChart.dispatchAction({
        type: 'hideTip'
      });
      if (vdata.length === 0) {
        return false;
      }
      if (_this.shopMapOpt.series[2].data) {
        const series = util.deepClone(_this.shopMapOpt.series[2].data);
        const valarr = convertData(vdata);
        _this.shopMapOpt.series[2].data = series.concat(valarr);
        if (valarr.length === 1) {
          setTimeout(() => {
            myChart.dispatchAction({
              type: 'showTip',
              seriesIndex: 2,
              dataIndex: series.length
            });
          }, 3000);
          setTimeout(() => {
            myChart.dispatchAction({
              type: 'hideTip'
            });
            _this.shopMapOpt.series[2].data = [];
          }, 5000);
        } else {
          let i = 0;
          const timer = setInterval(() => {
            if (i === valarr.length) {
              clearInterval(timer);
              myChart.dispatchAction({
                type: 'hideTip'
              });
              _this.shopMapOpt.series[2].data = [];
            }
            myChart.dispatchAction({
              type: 'showTip',
              seriesIndex: 2,
              dataIndex: series.length + i
            });
            console.log(i);
            i++;
          }, 3000);
        } 
      }         
    },
    fetchData() {
      this.queryMapProvinceShopsNum();
      this.queryYearShopTrend();
      this.queryYearSaleOrderCustTrend();
      this.queryYearStockCostTop();
      this.queryYearPayTypeRateTop();
      // 库存成本弹出框
      this.queryYearStockCostTopAll();
      // 支付习惯弹出框
      this.queryYearPayTypeRateTopAll();
      // 大屏销售明细
      this.queryYearSaleDetail();
      // 大屏当天统计结果返回（单金额，会员数量，成交件数）
      this.getPortalSaleSummary();
      // 大屏新增单据效果返回（地图上）
      this.getSheetAddAmount(); 
    },
    // 大屏新增门店效果返回
    getVirtualAddNum() {
      const _this = this;
      API.getVirtualAddNum().then((res) => {
        const json = res.data.data || [];
        if (json.length > 0) {
          const replaceList = replaceName(json, 'item');
          // const proviceList = replaceList.map((item) => ({ name: item.item, itemStyle: { areaColor: '#FFAA29' }, emphasis: { itemStyle: { areaColor: '#FFAA29' }}}));
          const seriesList = replaceList.filter((item) => item.value > 0).map((item) => ({ name: item.item, value: item.value }));
          const sum = seriesList.map((item) => item.value).reduce((total, num) => total + num);
          _this.seriesShopSum = sum;
          if (_this.shopNumMonth < _this.seriesShopSum) {
            _this.shopNumMonth = _this.seriesShopSum;
          }
          // const data = convertData(replaceList.sort((a, b) => b.value - a.value).slice(0, 50));
          // const shopMapOpt = util.deepClone(_this.shopMapOpt);
          // const arrName = replaceList.map((item) => item.item);
          // let { data } = shopMapOpt.series[0];
          // data = data.filter((item) => arrName.indexOf(item.name) < 0);
          // _this.shopMapOpt.series[0].data = data;
          _this.shopMapOpt.series[1].data = convertData(seriesList);
          // shopMapOpt.geo.regions = proviceList;
          // _this.shopMapOpt = shopMapOpt;        
        }
      });
    },
    // 大屏当天统计结果返回（单金额，会员数量，成交件数）
    getPortalSaleSummary() {
      const _this = this;      
      API.getPortalSaleSummary().then((res) => {
        const json = res.data.data || {};
        _this.todayCustomNum = json.customerAddNum || 0;
        _this.todaySaleNum = json.sheetTotalMoney || 0;
        _this.todayVolNum = json.saleNum || 0;
        _this.monthCustomNum = json.custMonthAdd || 0;
      });
    },
    // 大屏新增单据效果返回（地图上）
    getSheetAddAmount() {
      const _this = this;     
      API.getSheetAddAmount().then((res) => {
        const json = res.data.data || {};
        const sheetAvgOne = json.sheetAvgOne || 1;
        if (json.sheetList) {
          const sheetList = json.sheetList.filter((item) => item.sheetTotalMoney >= sheetAvgOne);
          // console.log(sheetList);
          if (sheetList.length > 0) {
            const replaceList = replaceName(sheetList, 'provice');
            // const provinceList = replaceList.map((item) => ({ name: item.provice, value: item.sheetTotalMoney }));
            const proviceList = replaceList.map((item) => ({ name: item.provice, itemStyle: { areaColor: '#1676FF' }, emphasis: { itemStyle: { areaColor: '#1676FF' }}}));
            const seriesList = replaceList.map((item) => ({ name: item.provice, value: item.sheetTotalMoney }));
            const data = convertData(seriesList);
            _this.sheetList = _this.sheetList.concat(data);
            _this.proviceList = _this.proviceList.concat(proviceList);
            _this.animation();
            // _this.shopTip(provinceList);
          }
        } 
        // console.log(json);        
        // _this.animation();
      });
    },
    // 查询地图各省门店数量,平台门店总数，top10取前10个省的
    queryMapProvinceShopsNum() {
      const _this = this;      
      API.queryMapProvinceShopsNum().then((res) => {
        const json = res.data.data || {};
        _this.shopNum = json.shopNum || 0;
        if (json.shopNumMonth) {
          _this.shopNumMonth = json.shopNumMonth > 0 ? json.shopNumMonth : 0;
        }        
        _this.shopTopList = json.shopTopList || [];
        let shopTopList = json.shopTopList.filter((item, index) => index < 5);
        shopTopList = replaceName(shopTopList, 'item');
        // 柱状图
        shopsBarOpt.yAxis[0].data = shopTopList.map((item) => item.item).reverse();
        shopsBarOpt.yAxis[1].data = shopTopList.map((item) => item.value);
        shopsBarOpt.series[0].data = shopTopList.map((item) => ({ value: item.value })).reverse();        
        _this.shopsBarOpt = shopsBarOpt;
        // 地图        
        const replaceList = replaceName(json.shopTopList, 'item');
        const provinceList = replaceList.map((item) => ({ name: item.item, value: item.value }));
        const data = convertData(provinceList);
        _this.shopMapOpt.series[0].data = data;       
        // _this.shopMapOpt = mapOpt;
        // 弹出框柱状图
        const innerShopsBarOpt = util.deepClone(innerBarOpt);
        const shopTopListAll = replaceName(json.shopTopList, 'item');
        innerShopsBarOpt.yAxis[0].data = shopTopListAll.map((item) => item.item).reverse();
        innerShopsBarOpt.yAxis[1].data = shopTopListAll.map((item) => item.value);
        innerShopsBarOpt.series[0].data = shopTopListAll.map((item) => ({ value: item.value })).reverse();        
        _this.innerShopsBarOpt = innerShopsBarOpt;
        // eslint-disable-next-line no-unused-vars        
        _this.getVirtualAddNum();
      });        
      // _this.setMap();
      
    },
    // 门店年增长趋势
    queryYearShopTrend() {
      const _this = this;      
      API.queryYearShopTrend({ year: _this.year }).then((res) => {
        const json = res.data.data || [];
        riseLineOpt.xAxis.data = json.map((item) => item.item);
        riseLineOpt.series[0].data = json.map((item) => item.value);
        _this.riseLineOpt = riseLineOpt;
        // console.log(res);
      });
    },
    // 查询 销售，成交，会员数据
    queryYearSaleOrderCustTrend() {
      const _this = this;      
      API.queryYearSaleOrderCustTrend({ year: _this.year }).then((res) => {
        const json = res.data.data || {};
        _this.custSum = json.custSum ? parseInt(json.custSum, 10) : 0;
        _this.goodsSum = json.goodsSum ? parseInt(json.goodsSum, 10) : 0;
        _this.saleSum = json.saleSum ? parseInt(json.saleSum, 10) / 10000 : 0;
        saleLineOpt.xAxis.data = json.saleTrendList.map((item) => parseInt(item.item, 10));
        saleLineOpt.series[0].data = json.saleTrendList.map((item) => item.value);
        if (json.saleTrendList.length > 0) {
          _this.monthSaleNum = json.saleTrendList[json.saleTrendList.length - 1].value;
        }
        _this.saleLineOpt = saleLineOpt;
        volLineOpt.xAxis.data = json.goodsTrendList.map((item) => parseInt(item.item, 10));
        volLineOpt.series[0].data = json.goodsTrendList.map((item) => item.value);
        if (json.goodsTrendList.length > 0) {
          _this.monthVolNum = json.goodsTrendList[json.goodsTrendList.length - 1].value;
        }
        _this.volLineOpt = volLineOpt;
        vipLineOpt.xAxis.data = json.custTrendList.map((item) => parseInt(item.item, 10));
        vipLineOpt.series[0].data = json.custTrendList.map((item) => item.value);
        _this.vipLineOpt = vipLineOpt;
        // console.log(res);
      });
    },
    // 查询各省平均库存量top，各省平均铺货成本top
    queryYearStockCostTop() {
      const _this = this;      
      API.queryYearStockCostTop({ limit: 5, year: _this.year }).then((res) => {
        const json = res.data.data || {};
        const stockTopListAll = replaceName(json.stockTopList, 'item');
        const stockTopList = stockTopListAll.filter((item, index) => index < 5);
        stockBarOpt.yAxis[0].data = stockTopList.map((item) => item.item).reverse();
        stockBarOpt.yAxis[1].data = stockTopList.map((item) => item.value);
        stockBarOpt.series[0].data = stockTopList.map((item) => ({ value: parseFloat(item.value / 1000).toFixed(2) })).reverse();
        _this.stockBarOpt = stockBarOpt;
        const costTopListAll = replaceName(json.costTopList, 'item');
        const costTopList = costTopListAll.filter((item, index) => index < 5);
        costBarOpt.yAxis[0].data = costTopList.map((item) => item.item).reverse();
        costBarOpt.yAxis[1].data = costTopList.map((item) => item.value);
        costBarOpt.series[0].data = costTopList.map((item) => ({ value: parseFloat(item.value / 10000).toFixed(2) })).reverse();
        _this.costBarOpt = costBarOpt;
      });
    },    
    // 支付方式占比,和支付类型占比top1的省
    queryYearPayTypeRateTop() {
      const _this = this;      
      API.queryYearPayTypeRateTop({ limit: 5, year: _this.year }).then((res) => {
        const json = res.data.data || {};
        const payRateList = json.payRateList.map((item) => ({ name: item.item, value: parseInt(item.value * 100, 10) }));
        payPieOpt.series[0].data = payRateList;
        payPieOpt.title.text = `${parseFloat(_this.saleSum / 10000).toFixed(2)}`;
        _this.payPieOpt = payPieOpt;
        // eslint-disable-next-line consistent-return
        const payTopList = [];
        const payTopListAll = replaceName(json.payTopList, 'item');
        payTopListAll.forEach((item, index) => { 
          if (index === 0 || index === 5 || index === 10 || index === 15 || index === 20) {
            payTopList.push({ name: item.item, value: parseInt(item.value * 100, 10) });
          }
        });
        _this.habitPieOpt = habitPieOpt(payTopList);
        // 设置环形图动画
        if (!_this.payTimer) {
          _this.setPayPie();
        }
      });
    },
    // 库存成本
    queryYearStockCostTopAll() {
      const _this = this;      
      API.queryYearStockCostTop({ limit: 0, year: _this.year }).then((res) => {
        const json = res.data.data || {};
        const innerStockBarOpt = util.deepClone(innerBarOpt);
        const stockTopList = replaceName(json.stockTopList, 'item');
        innerStockBarOpt.yAxis[0].data = stockTopList.map((item) => item.item).reverse();
        innerStockBarOpt.yAxis[1].data = stockTopList.map((item) => item.value);
        innerStockBarOpt.series[0].data = stockTopList.map((item) => ({ value: parseFloat(item.value / 1000).toFixed(2) })).reverse();
        _this.innerStockBarOpt = innerStockBarOpt;
        const innerCostBarOpt = util.deepClone(innerBarOpt);
        const costTopList = replaceName(json.costTopList, 'item');
        innerCostBarOpt.yAxis[0].data = costTopList.map((item) => item.item).reverse();
        innerCostBarOpt.yAxis[1].data = costTopList.map((item) => item.value);
        innerCostBarOpt.series[0].data = costTopList.map((item) => ({ value: parseFloat(item.value / 10000).toFixed(2) })).reverse();
        _this.innerCostBarOpt = innerCostBarOpt;
      });
    },
    // 支付方式占比明细
    queryYearPayTypeRateTopAll() {
      const _this = this;      
      API.queryYearPayDetail({ limit: 0, year: _this.year }).then((res) => {
        const json = res.data.data || [];
        // const payRateList = json.payRateList.map((item) => ({ name: item.item, value: item.value }));
        // payPieOpt.series[0].data = payRateList;
        // _this.payPieOpt = payPieOpt;
        // eslint-disable-next-line consistent-return
        const innerWeixinBarOpt = util.deepClone(innerBarOpt);  
        const payTopListAll = replaceName(json, 'item');
        const weixinList = payTopListAll.filter((item) => item.itemType === '微信');
        innerWeixinBarOpt.yAxis[0].data = weixinList.map((item) => item.item).reverse();
        innerWeixinBarOpt.yAxis[1].data = weixinList.map((item) => item.value);
        innerWeixinBarOpt.series[0].data = weixinList.map((item) => ({ value: parseFloat(item.value / 10000).toFixed(2) })).reverse();
        _this.innerWeixinBarOpt = innerWeixinBarOpt;
        const innerAlipayBarOpt = util.deepClone(innerBarOpt);
        const alipayList = payTopListAll.filter((item) => item.itemType === '支付宝');
        innerAlipayBarOpt.yAxis[0].data = alipayList.map((item) => item.item).reverse();
        innerAlipayBarOpt.yAxis[1].data = alipayList.map((item) => item.value);
        innerAlipayBarOpt.series[0].data = alipayList.map((item) => ({ value: parseFloat(item.value / 10000).toFixed(2) })).reverse();
        _this.innerAlipayBarOpt = innerAlipayBarOpt;
        const innerCardBarOpt = util.deepClone(innerBarOpt);
        const cardList = payTopListAll.filter((item) => item.itemType === '刷卡');
        innerCardBarOpt.yAxis[0].data = cardList.map((item) => item.item).reverse();
        innerCardBarOpt.yAxis[1].data = cardList.map((item) => item.value);
        innerCardBarOpt.series[0].data = cardList.map((item) => ({ value: parseFloat(item.value / 10000).toFixed(2) })).reverse();
        _this.innerCardBarOpt = innerCardBarOpt;
        const innerCashBarOpt = util.deepClone(innerBarOpt);
        const cashList = payTopListAll.filter((item) => item.itemType === '现金');
        innerCashBarOpt.yAxis[0].data = cashList.map((item) => item.item).reverse();
        innerCashBarOpt.yAxis[1].data = cashList.map((item) => item.value);
        innerCashBarOpt.series[0].data = cashList.map((item) => ({ value: parseFloat(item.value / 10000).toFixed(2) })).reverse();
        _this.innerCashBarOpt = innerCashBarOpt;
        const innerMashupBarOpt = util.deepClone(innerBarOpt);
        const mashupList = payTopListAll.filter((item) => item.itemType === '聚合支付');
        innerMashupBarOpt.yAxis[0].data = mashupList.map((item) => item.item).reverse();
        innerMashupBarOpt.yAxis[1].data = mashupList.map((item) => item.value);
        innerMashupBarOpt.series[0].data = mashupList.map((item) => ({ value: parseFloat(item.value / 10000).toFixed(2) })).reverse();
        _this.innerMashupBarOpt = innerMashupBarOpt;
      });
    },
    // 销售明细
    queryYearSaleDetail() {
      const _this = this;
      API.queryYearSaleDetail({ year: _this.year }).then((res) => {
        const json = res.data.data || [];
        const custDetailsListOpt = util.deepClone(innerBarOpt);
        const custDetailsList = replaceName(json.custDetailsList, 'province');
        custDetailsListOpt.yAxis[0].data = custDetailsList.map((item) => item.province).reverse();
        custDetailsListOpt.yAxis[1].data = custDetailsList.map((item) => item.totalNum);
        custDetailsListOpt.series[0].data = custDetailsList.map((item) => ({ value: item.totalNum })).reverse();
        _this.custDetailsList = custDetailsListOpt;
        const goodsDetailsListOpt = util.deepClone(innerBarOpt);
        const goodsDetailsList = replaceName(json.goodsDetailsList, 'province');
        goodsDetailsListOpt.yAxis[0].data = goodsDetailsList.map((item) => item.province).reverse();
        goodsDetailsListOpt.yAxis[1].data = goodsDetailsList.map((item) => item.totalNum);
        goodsDetailsListOpt.series[0].data = goodsDetailsList.map((item) => ({ value: item.totalNum })).reverse();
        _this.goodsDetailsList = goodsDetailsListOpt;
        const saleDetailsListOpt = util.deepClone(innerBarOpt);
        const saleDetailsList = replaceName(json.saleDetailsList, 'province');
        saleDetailsListOpt.yAxis[0].data = saleDetailsList.map((item) => item.province).reverse();
        saleDetailsListOpt.yAxis[1].data = saleDetailsList.map((item) => item.totalNum);
        saleDetailsListOpt.series[0].data = saleDetailsList.map((item) => ({ value: parseFloat(item.totalNum / 10000).toFixed(2) })).reverse();
        _this.saleDetailsList = saleDetailsListOpt;
        // console.log(json);
      });
    },
    prevYear() {
      const date = new Date(this.date);
      date.setFullYear(date.getFullYear() - 1);
      this.date = date;
      if (this.isRequest === 2) {
        return;
      }
      this.fetchData();
    },
    nextYear() {
      const date = new Date(this.date);
      date.setFullYear(date.getFullYear() + 1);
      this.date = date;
      if (this.isRequest === 2) {
        return;
      }
      this.fetchData();
    },
    setPayPie() {
      if (this.isRequest === 2) {
        return;
      }
      if (this.payTimer) {
        return;
      }  
      const myChart = this.$refs.payPie.chart;
      let index = 0;
      if (this.payPieOpt && typeof this.payPieOpt === 'object') {
        myChart.setOption(this.payPieOpt, true);
      }          
      this.payTimer = setInterval(() => {
        myChart.dispatchAction({
          type: 'hideTip',
          seriesIndex: 0,
          dataIndex: index
        });
        // 显示提示框
        myChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: index
        });
        // 取消高亮指定的数据图形
        myChart.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex: index === 0 ? 3 : index - 1
        });
        myChart.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: index
        });
        index++;
        if (index > 3) {
          index = 0;
        }
      }, 3000);
    },
    setMap() {
      const myChart = this.$refs.map.chart;
      let index = 0;
      // eslint-disable-next-line no-var
      this.showTip = setInterval((_) => {
        myChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 1,
          dataIndex: index
        });
        index++;
        if (index >= this.shopMapOpt.series[1].data.length) {
          index = 0;
        }
      }, 4000);
      myChart.on('mouseover', (params) => {
        // console.log(params);
        clearInterval(this.showTip);
        myChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 1,
          dataIndex: params.dataIndex,
        });
      });
      myChart.on('mouseout', (params) => {
        // eslint-disable-next-line no-unused-expressions
        this.showTip && clearInterval(this.showTip);
        // eslint-disable-next-line no-const-assign
        this.showTip = setInterval(() => {
          myChart.dispatchAction({
            type: 'showTip',
            seriesIndex: 1,
            dataIndex: index
          });
          index++;
          if (index >= this.shopMapOpt.series[1].data.length) {
            index = 0;
          }
        }, 4000);
      });
    },
    setZero(a) { //设置小于10的数字在加0
      return a < 10 ? `0${a}` : a;
    },
    showModal(index) {
      // const _this = this;
      this.tabActive = index;
      this.modalShow = true;
      switch (index) {
        case 0:
          // _this.innerStockBarOpt = innerStockBarOpt;
          // _this.innerCostBarOpt = JSON.parse(JSON.stringify(_this.costBarOpt));
          break;
        default:
          break;
      }
      // eslint-disable-next-line no-unused-expressions
      this.showTip && clearInterval(this.showTip);
      const myChart = this.$refs.map.chart;
      myChart.dispatchAction({
        type: 'hideTip',
        seriesIndex: 1,
      });
    },
    hideModal() {
      this.modalShow = false;
      const myChart = this.$refs.map.chart;
      let index = 0;
      // eslint-disable-next-line no-const-assign
      this.showTip = setInterval(() => {
        myChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: index
        });
        index++;
        if (index >= this.shopMapOpt.series[0].data.length) {
          index = 0;
        }
      }, 2000);
    },
  },
  filters: {
    formatDate(date, vm) { //当前时间格式化处理
      let str = '';
      str += `${vm.setZero(date.getFullYear())}-`; //获取年份
      str += `${vm.setZero(date.getMonth() + 1)}-`; //获取月份
      str += `${vm.setZero(date.getDate())}`; //获取日
      str += ` ${vm.setZero(date.getHours())}:`; //获取时
      str += `${vm.setZero(date.getMinutes())}:`; //获取分
      str += vm.setZero(date.getSeconds()); //获取秒
      return str;
    },
  },
  components: {
    CountTo,
  }
};
</script>
<style lang="less">
.echarts{
  width: 100%!important;
  height: 100%!important;
}
.page-map{
  position: absolute;
  left: 0;
  top: 0;
  width: 80%;
  height: 1080px;
}
#map_container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  margin: 0;
}
</style>
